module.exports = __webpack_public_path__ + "static/media/place_pin.09bb4b10.png";